import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

export const equipmentTypeApiSchema = v.object({
  description: v.string(),
  id: v.number(),
});

export const equipmentTypeSchema = v.object({
  ...equipmentTypeApiSchema.entries,
  ...optionSchema.entries,
});

export const equipmentTypesApiSchema = paginatedSchema(equipmentTypeApiSchema);

export type EquipmentTypeApi = v.InferOutput<typeof equipmentTypeApiSchema>;
export type EquipmentTypesApi = v.InferOutput<typeof equipmentTypesApiSchema>;

export type EquipmentTypeFilters = Filters<EquipmentTypeApi>;

export type EquipmentTypeFiltersUpdateApi = FiltersUpdateApi<EquipmentTypeApi>;

export type EquipmentType = Prettify<Option<v.InferOutput<typeof equipmentTypeSchema>>>;

export type EquipmentTypes = Entities<EquipmentType>;
